export enum CheckoutParentLifecycleEventPostMessageName {
    preticketsOrganizerLayoutUpdate = 'preticketsOrganizerLayoutUpdate',
    setTickets = 'setTickets',
}

export enum LayoutDirection {
    horizontal = 'horizontal',
    vertical = 'vertical',
}
